// Module
var code = "<div class=\"subscription-title-container\">\n    <h2 class=\"subscription-title-container__title\">Choose your plan</h2>\n    <p class=\"subscription-title-container__plan-promotion-text\">\n        {promotionText}\n    </p>\n</div>\n";
// Exports
module.exports = code;